<template>
  <div>
    <!-- 卡片组件 -->
    <el-card class="transit-card">
      <!-- 全选复选框 -->
      <div style="margin-bottom: 10px;">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      </div>

      <div v-for="(record, index) in paginatedRecords" :key="index" class="transit-item">
        <el-checkbox v-model="record.selected" @change="handleCheckedChange"></el-checkbox>
        <el-tag :type="record.type === '进入' ? 'success' : 'warning'" style="margin-left: 5px;">
          {{ record.type }}
        </el-tag>
        <span class="time">{{ formatTime(record.timestamp) }}</span>
        <div class="user-info">
          <span>姓名：{{ record.visitorName || "未知" }}</span>
          <span>性别：{{ record.sex || "未知" }}</span>
          <span>来访单位：{{ record.company || "未知" }}</span>
          <span>手机号：{{ record.phone || "未知" }}</span>
          <span>拜访开始时间：{{ record.date1 ? formatTime(record.date1) : "未知" }}</span>
          <span>拜访结束时间：{{ record.date2 ? formatTime(record.date2) : "未知" }}</span>
        </div>
      </div>
    </el-card>

    <!-- 清空按钮 -->
    <div style="text-align: center; margin-top: 10px;">
      <el-button type="danger" @click="clearSelectedRecords">清空选中记录</el-button>
    </div>

    <!-- 分页组件 -->
    <div style="text-align: center; margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :total="totalRecords"
        layout="total, prev, pager, next"
      >
      </el-pagination>
    </div>
    <div >
      <footers/>
    </div>
  </div>
</template>

<script>
import footers from '../components/footer.vue'

export default {
  components: {
    footers
  },
  data() {
    return {
      records: [],
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0, // 记录总数
      checkAll: false, // 全选状态
      isIndeterminate: false, // 中间状态（部分选中）
    };
  },

  methods: {
    async loadRecords() {
      try {
        const response = await this.$http.get("/order-transits");
        if (response && Array.isArray(response)) {
          this.records = response.map((record) => ({
            ...record,
            date1: record.visitStartTime ? new Date(record.visitStartTime) : null,
            date2: record.visitEndTime ? new Date(record.visitEndTime) : null,
            timestamp: record.timestamp ? new Date(record.timestamp) : null,
            selected: false, // 添加一个selected属性用于记录是否被选中
          }));
          this.totalRecords = this.records.length;
        } else {
          console.warn("Invalid data format received from server");
          this.$message.warning("服务器返回的数据格式不正确");
        }
      } catch (error) {
        console.error("加载记录失败:", error);
        this.$message.error("加载记录失败，请稍后再试");
      }
    },

    formatTime(date) {
      if (!date) return "未知";
      return date.toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    },

    handleSizeChange(newSize) {
      this.pageSize = newSize;
    },

    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    },

    handleCheckAllChange(val) {
      this.paginatedRecords.forEach(record => {
        this.$set(record, 'selected', val);
      });
      this.isIndeterminate = false;
    },

    handleCheckedChange(value) {
      const checkedCount = this.paginatedRecords.filter(record => record.selected).length;
      this.checkAll = checkedCount === this.paginatedRecords.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.paginatedRecords.length;
    },

    async clearSelectedRecords() {
      const selectedIds = this.paginatedRecords.filter(record => record.selected).map(record => record._id);

      if (selectedIds.length > 0) {
        try {
          await this.$http.delete("/order-transits", { data: { ids: selectedIds } });
          this.records = this.records.filter(record => !selectedIds.includes(record._id));
          this.totalRecords = this.records.length; // 更新总记录数
          this.$message.success("已成功删除选中的记录");
        } catch (error) {
          console.error("删除记录失败:", error);
          this.$message.error("删除记录失败，请稍后再试");
        }
      }

      this.checkAll = false;
      this.isIndeterminate = false;
    },
  },
  mounted() {
    this.loadRecords(); // 组件挂载时加载记录
  },
  computed: {
    paginatedRecords() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.records.slice(start, end);
    },
  },
};
</script>

<style scoped>
.transit-card {
  margin: 20px;
}

.transit-item {
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
}

.time {
  margin-left: 18px;
  color: #909399;
}

.user-info {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}
</style>